import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function NotFoundPage() {
  const { t } = useLanguage();
  return (
    <div data-testid="not-found-page" className="container-site py-24 sm:py-36 text-center">
      <p className="font-mono text-sm text-ochre">404</p>
      <h1 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{t.notFound.title}</h1>
      <p className="mt-4 text-muted-foreground">{t.notFound.text}</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-ochre active:scale-[0.98]"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {t.notFound.cta}
      </Link>
    </div>
  );
}
